const FieldWrapper = ({field, index, formIndex, inline, classCallback = (field)=> "", message, fieldClass, label, style, loading, error, errors, children, allowNull, hideLabel, helpText, excludeLabel=false, excludeWrapper=false }) => {
    if(excludeWrapper){
        return children
    }
    return (
        <>
        {message && <div className="" dangerouslySetInnerHTML={{ __html: message }} />}
        <div 
            id={`wrapper-${field.fieldName}`}
            className={`${(fieldClass && fieldClass)} ${(classCallback && classCallback(field))} ${(style) ? style.wrapper_class : ''} ${(loading) ? 'loading' : ''}  ${error || (errors && errors.length > 0) ? 'has-error' : ''}`}>

            {label && (inline && index==0 || !inline) && !excludeLabel && (
            <label className={`col-form-label ${hideLabel ? 'sr-only' : ''}`}>
                {label}{!allowNull && '*'}
            </label>
            )}
            {children}
            {errors.length > 0 &&
                errors.map((error, index) => (
                    <span className="invalid-feedback" key={index}>
                    {error}
                    </span>
            ))}
            {helpText && (!inline)  ?<small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: helpText }} /> : ''}
        </div>
        </>
    )
}

export default FieldWrapper